import type { IconName } from "@@/shared/icon-name";
import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

type IconLibrary = "regular" | "solid" | "duotone" | "light" | "brand" | "thin";

const singleContentPageBlockStyleTypes = ["solid", "loose"] as const;

type SingleContentPageBlockStyleType =
    (typeof singleContentPageBlockStyleTypes)[number];
const singleContentPageBlockStyleType =
    toObjectMap<SingleContentPageBlockStyleType>([
        ...singleContentPageBlockStyleTypes,
    ]);
const singleContentPageBlockStyleTypeMeta: Record<
    SingleContentPageBlockStyleType,
    {
        iconName: IconName;
        name: Translatable;
        iconLibrary?: IconLibrary;
    }
> = {
    loose: {
        iconName: "fa-rectangle",
        iconLibrary: "regular",
        name: translation({
            sv: "Lös form",
            en: "Loose",
        }),
    },
    solid: {
        iconName: "fa-rectangle",
        iconLibrary: "solid",
        name: translation({
            sv: "Fast form",
            en: "Solid",
        }),
    },
};
const singleContentPageBlockStyleTypeZodSchema = z.enum(
    singleContentPageBlockStyleTypes,
);

export {
    singleContentPageBlockStyleType,
    singleContentPageBlockStyleTypeMeta,
    singleContentPageBlockStyleTypeZodSchema,
};
export type { SingleContentPageBlockStyleType };
